export * from '@nuxt-common/profile-management/config.bcom.js';
export * from '@nuxt-common/left-nav/config.bcom.js';
export * from '@nuxt-common/login-component/config.bcom.js';
export * from '@nuxt-common/credit-gateway/config.bcom.js';
export * from '@nuxt-common/create-account-component/config.bcom.js';
export * from '@nuxt-common/payment-cards/config.bcom.js';
export * from '@nuxt-common/account-verification-component/config.bcom.js';
export * from '@nuxt-common/creditcard-banner-consumable/config.bcom.js';

export const brand = 'bcom';
export const brandName = 'Bloomingdale’s';
export const onlineGuid = 'bloomingdales_online_guid';
export const onlineUid = 'bloomingdales_online_uid';
export const separateEntity = {
  SE_MATCH: () =>
    "We recently mailed a replacement Bloomingdale's Credit Card for each user of this account to the primary card holder. Your bWallet was automatically updated with your replacement card number.",
  SE_MISMATCH: (preDuality) =>
    preDuality
      ? 'We recently mailed a replacement Bloomingdale\'s Credit Card for each user of this account to the primary card holder. You need to add your replacement card to your bWallet. If the primary card holder did not receive your replacement card, they can call 855-926-1648 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>'
      : 'We recently mailed a replacement Bloomingdale\'s Credit Card for each user of this account to the primary card holder. You need to add your replacement card to your bWallet as your old card is no longer valid. If the primary card holder did not receive your replacement card, they can call 855-926-1648 or TTY 711.<br /><a class="add-a-new-card" href="#">Add your replacement card</a>',
};
export const giftCardImageUrl = (productImageUrl) =>
  `https://images.${window.location.hostname.replace('www.', '')}/is/image/BLM/products/${productImageUrl}.tif`;
export const MY_ACCOUNT_FALL_BACK_ERROR = "We're sorry, but we cannot display your information at this time.";
export const DEFAULT_DISCOUNT = 20;
export const OFFERPROMOS = {
  title: 'Offers & Promos',
  viewAllText: 'View all offers',
  viewAllUrl: '/shop/coupons-sales-promotions',
  linkStyle: 'link-sm',
  serviceInterruption: 'Service Interruption',
  promoColor: 'sale-color',
  promoCode: 'Promo Code',
  noPromoCode: 'No Promo Code',
  shopNow: 'Shop Now',
  exclusionDetails: 'Exclusion & Details',
  exclusionDetailsSlideoutTitle: 'Exclusion & Details',
  offerErrorPrimaryText: "You don't have any saved offers. To view and add offers, visit",
  offerErrorSecondaryText: 'Deals & Promotions',
  offerErrorLink: '/shop/coupons-sales-promotions',
  tag: {
    event_name: 'my account overlay',
    link_name: 'exclusion and details',
  },
};
export const CREDIT_CARD = {
  heading: 'Bloomingdale’s Credit Card',
  maintenanceAlertTitle: 'Maintenance Alert',
  serviceInterruptionTitle: 'Service Interruption',
  importantNotice:
    "Because you have added your Bloomingdale’s Credit Card to this section of the bloomingdales.com website, information about your Bloomingdale’s Credit Card, such as account balance, available credit and bank account information, is visible on bloomingdales.com as well as on the credit card issuer's website. Anyone who has or gains access to your bloomingdales.com sign-in will have access to your financial information displayed here. You should not give access to your bloomingdales.com sign-in to anyone you would not want to have access to your financial information. If you have concerns about anyone with access to your Bloomingdale’s sign-in seeing your information, you should change the password associated with your Bloomingdale’s sign-in, or contact customer service at 1-888-257-6762 to discuss additional options.",
  errorMessage: "We're sorry, but we cannot display your Bloomingdale's Credit Card information at this time.",
  gatewayLink: (index, query = '') => `/my-credit/gateway/cards/${index}?linklocation=pagecontent${query}`,
  emptyCard: {
    propsCardImage: 'blm_creditcard.png',
    title: 'Already have a card?',
    description: 'Add your card to easily make payments and manage your credit account online.',
    addTagLink: 'add your Bloomingdale’s card',
    addCardLabel: 'Add your card',
    openCardOffer: {
      title: "Don't have a Card?",
      description: (discount) =>
        `Open a Bloomingdale's Credit Card and take ${discount}% off your Bloomingdale's purchases today and tomorrow (up to total savings of $250 over the two days).`,
      learnUrl: '/loyallist/accountsummary',
      learnLabel: 'Learn More',
      subjectToApprovalLabel: 'Subject to credit approval.',
      exclusionsUrl: '/customer-service/articles/what-is-the-bloomingdales-new-account-discount',
      exclusionsLabel: (discount) => (discount === '20' ? 'Info/Exclusions' : 'Promotional Info/Exclusions'),
    },
  },
  paymentCard: {
    endingIn: 'Ending in:',
    minimumPayment: 'Minimum Payment:',
    dueDate: 'Due Date:',
    nextAutoPayment: 'Next Autopayment:',
    currentBalance: 'Current Balance:',
    availableCredit: 'Available Credit:',
    makeAPaymentLabel: 'Make A Payment',
    importantNoticeLabel: 'Important Notice',
    viewDetailsLabel: 'View Details',
    tag: {
      selectedCardPersistentLogin: {
        page_type: 'step up login',
        page_name: 'home credit card view details',
        event_name: "view bloomingdale's card details",
        link_name: "view bloomingdale's card details",
      },
      selectedCard: {
        event_name: "view bloomingdale's card details",
        link_name: "view Bloomingdale's card details",
      },
      legalNotice: {
        event_name: 'my account overlay',
        link_name: 'important notice',
      },
      maintenanceAlert: {
        event_name: 'my account overlay',
        link_name: 'maintenance alert',
      },
      makePaymentView: {
        page_type: 'step up login',
        page_name: 'home credit card make a payment',
        link_name: 'make a payment',
      },
      makePaymentLink: {
        link_name: 'make a payment',
        event_name: 'make a payment',
      },
    },
  },
  cardSlideout: {
    currentBalance: 'Current balance',
    defaultCard: 'Default card',
    propCardTitle: 'Bloomingdale’s Credit Card',
    inStorePurchases: 'In-Store Purchases',
    amexCardTitle: 'Bloomingdale’s American Express® Card',
    outsidePurchases: 'Outside Purchases',
  },
  dualLineSummary: {
    minimumPayment: 'Minimum payment',
    dueDate: 'Due date',
    availableCredit: 'Available credit',
    importantNotice: 'Important notice',
    importantNoticeLabel: 'Important Notice',
    viewDetails: 'View Details',
    makeAPayment: 'Make A Payment',
    nextAutoPayment: 'Next Autopayment',
    currentBalance: 'Current Balance',
    creditSummary: 'Credit summary',
  },
  attentionOverlay: {
    message: "There's no need to make a payment this time because you have a zero balance.",
    okLabel: 'OK',
  },
  amexOffers: {
    heading: 'Amex Offers',
    simplyActivateLink: 'Simply activate offers',
    simplyActivateMessage: ', then pay with your Card to receive a statement credit, ',
    simplyActivateTerms: 'terms apply',
    activateOffersMessage:
      'By clicking “Offers”, I agree that Bloomingdale’s can share my Bloomingdale’s American Express card number with American Express.',
    termsLabel: 'Terms',
    offersLabel: 'Offers',
    termsAndConditionsTitle: 'Terms & Conditions',
  },
  amexTerms: {
    informationSharing: {
      header: 'INFORMATION SHARING',
      body: {
        part1: 'When you click ',
        part2:
          ', your Bloomingdale’s American Express Card number will be shared with American Express. American Express will retain your card number. In the event you activate an offer, American Express will use your card number to fulfill activated offers if you make the required purchase(s).',
      },
      offerTextWithConsent: '"Simply activate offers"',
      offerTextWithoutConsent: '"Offers"',
    },
    offerActivation: {
      header: 'OFFER ACTIVATION',
      body: {
        part1: 'All available offers will be shown by clicking on ',
        part2:
          '. To earn a statement credit, activate the offer and spend the amount specified in the offer at the specified merchant on your Bloomingdale’s American Express Card prior to the offer expiration date.',
      },
      offerTextWithConsent: '"Simply activate offers"',
      offerTextWithoutConsent: '"Offers"',
    },
    statementCredit: {
      header: 'STATEMENT CREDIT ISSUANCE',
      body: 'Statement Credits will appear on your statement within ninety (90) days following the end of the applicable offer period. Statement Credits may be reversed if a qualifying transaction is returned/cancelled.',
    },
    disclaimer:
      'American Express Travel Related Services Company Inc. is solely responsible for these offers, and is not affiliated with Macy’s Inc., Citibank, N.A. or their affiliates.',
    programTerms: {
      label: 'Amex Program Terms',
      url: 'http://www.amexoffers.com/partnerterms',
    },
  },
};
export const WALLET = {
  heading: 'bWALLET',
  menuLabel: 'My bWallet',
  addCardLabel: 'Add a card',
  serviceInterruptionLabel: 'Service Interruption',
  cardSaveSuccess: 'Changes saved to your bWallet.',
  editLabel: 'Edit',
  defaultLabel: 'Default',
  defaultCardLabel: 'Default Card',
  removeLabel: 'Remove',
  cardLimit: 10,
  addCreditCardTitle: 'Add Credit Card',
  editCreditCardTitle: 'Edit Credit Card',
  deleteConfirmMessage: 'Are you sure you want to delete this card',
  setAsDefaultLabel: 'Set as default',
  emptyWallet: {
    description: 'ADD A PAYMENT METHOD',
    subDescription: 'Securely save a card for a faster, easier checkout experience.',
    addPaymentLabel: 'ADD A CARD',
  },
  cardImages: {
    U: {
      image: 'bloomingdalesprop.png',
      altText: "Bloomingdale's Prop Card",
    },
    B: {
      image: 'bloomingdalesamex.png',
      altText: "Bloomingdale's American Express Card",
    },
    M: {
      image: 'mastercard_logo.png',
      altText: 'MasterCard',
    },
    V: {
      image: 'visa_logo.png',
      altText: 'Visa',
    },
    O: {
      image: 'discover_logo.jpg',
      altText: 'Discover',
    },
    A: {
      image: 'amex_logo.png',
      altText: 'American Express',
    },
    F: {
      image: 'bloomingdalesprop.png',
      altText: "Bloomingdale's Employee Card",
    },
  },
  paymentCardSlideout: {
    cardNames: ['bloomingdalesprop', 'bloomingdalesamex', 'Bloomingdale’s American Express', 'Bloomingdale’s', 'employeeCard'],
  },
  amexOffers: {
    heading: 'Amex Offers',
    simplyActivateLink: 'Simply activate offers',
    simplyActivateMessage: ', then pay with your Card to receive a statement credit, ',
    simplyActivateTerms: 'terms apply',
    activateOffersMessage:
      'Activate offers, pay by card, get statement credits! By clicking offers, you agree to let Bloomingdale’s share your card number with Amex.',
    termsLabel: 'Terms',
    offersLabel: 'Offers',
  },
  tag: {
    addCard: {
      event_name: 'add a card',
      link_name: 'edit account',
      site_action: 'add card start',
    },
    editCard: {
      event_name: 'edit a card',
      link_name: 'edit a card',
    },
    deleteCardStart: {
      site_action: 'delete card start',
      action_location: 'my account:home',
      event_name: 'edit account',
      link_name: 'edit account',
    },
    deleteCardComplete: {
      site_action: 'delete card complete',
      action_location: 'my account:home',
      event_name: 'edit account',
      link_name: 'edit account',
    },
  },
};

export const PURCHASE_HISTORY = {
  purchaseHistoryLabel: 'Purchases & Returns',
  noPurchasesAvailable: 'NO PURCHASES YET',
  noPurchasesAvailableSubHeading: 'Once you make a purchase while signed in, the details will appear here.',
  startShopping: 'Shop Now',
};
export const WISHLIST = {
  listText: 'Wish Lists',
  viewAllText: 'View all',
  goToText: 'Go to',
  redirectionUrl: '/wishlist/home?linklocation=pagecontent',
  createListLabel: 'KEEP TRACK OF YOUR FAVORITES',
  createListSubLabel: 'Tap the heart next to any item to save it here.',
  manageListText: 'CREATE A LIST',
};
export const LOYALTY = {
  salutation: (firstName) => `Hi, ${firstName}`,
  pointDetails: (points) => `You’re ${points} points away from your next Reward`,
  dashboardLink: '/loyallist/accountsummary?cm_sp=my_account-_-loyallist-_-view_loyallist_account',
  dashboardText: 'View my dashboard',
  noLoyaltyText: "Everyone's invited! The more you spend, the more perks and points you'll receive—no matter how you pay.",
  noLoyaltySignUpText: "Sign up in seconds (it's free)!",
  defaultMaxPointsThreshold: 5000,
  rewards: '5000 points = $25 Reward',
  joinNowLink: '/loyallist/enrollment?cm_sp=my_account-_-loyallist-_-become_a_loyallist',
  defaultTrackerTierName: 'loyallist',
};
export const INBOX = {
  rewardsLabel: 'Loyallist Rewards',
  viewButtonLabel: ' VIEW DETAILS',
  ordersLabel: 'Orders',
  noNewMessageText: 'You have no new messages.',
  creditCards: {
    heading: 'Bloomingdale’s Credit Card',
    walletUrl: '/account/wallet?ocwallet=true',
    manageCardText: (cardNumber) => `Download statements, make payments and manage your Bloomingdale’s Card ending in ${cardNumber} online.`,
    addCardAriaLabel: 'add your bloomingdale’s card button',
    addCardButtonLabel: 'ADD YOUR BLOOMINGDALE’S CARD',
    setDefaultCardText: 'Set your Bloomingdale’s Card as your default card to earn Loyalty Rewards for your purchases.',
    setAsDefaultAriaLabel: 'set as default button',
    setAsDefaultButtonLabel: 'SET AS DEFAULT',
  },
  addCardToWallet: {
    walletLabel: 'bWallet',
    saveCreditCard: 'Checkout in just a few clicks by securely saving a credit card in your bWallet.',
    addCardLabel: 'ADD A CREDIT CARD',
    saveChangesToWallet: 'Changes saved to your bWallet.',
    addCardSlideoutId: 'add-SlideOut',
  },
  enrollRewards: {
    signUpForStarRewards: "It's free! Sign up for Loyalty Rewards to earn rewards when you shop at Bloomingdale’s.",
    enrollTodayLabel: 'ENROLL TODAY',
    rewardsPageUrl: '/loyallist/accountsummary',
  },
  rewardCards: {
    congratsText: 'Congrats!',
    rewardsEarned: "You've earned",
    redeemText: 'Reward! Redeem it online or in store.',
    viewButtonLabel: 'view details button',
  },
};
export const MESSAGES = {
  userCreationMessage: 'Hooray! Your Bloomingdale’s account has been created and linked to your existing Loyallist membership',
  successfulUserCreationWithRewards: 'Congrats! You created a Bloomingdale’s account & added your Loyallist membership.',
  viewBenefits: 'View your benefits',
  congratsText: 'Congrats,',
  successfulUserCreation: 'Hooray! Your Bloomingdale’s account has been created.',
  loyaltyAutoEnrollmentMessage: 'Congrats! You created a Bloomingdale’s account & added your Loyallist membership.',
};
export const DASHBOARD = {
  tag: {
    defaultErrorCode: '999',
    defaultErrorLabel: ['api response error'],
    error: {
      event_name: 'My account error',
      error_category: 'my account',
      error_misc: [''],
    },
  },
};

export const GIFT_CARD_BALANCE = {
  checkBalance: `Enter the 18 or 19 digit number on the back of your Gift Card. You may need to remove a scratch-off tab to see all of the numbers.
      For E-Gift Cards, please follow the instructions from the email we sent.`,
  usingGiftCard: `If you are using an E-Gift Card (received by email), the Gift Card number may be displayed as a single 18 to 19 digit number.
                Please follow the instructions from the email we sent.<br><br>If you are using a physical gift card, both a 15-digit Gift Card number and a 3 to 4 digit CID number are located
                on the back of your card. You may have to scratch off a silver film to reveal both numbers.`,
  imageAltText: 'Gift Card Number',
  cidImageAltText:
    'Your CID number is the last set of 3 or 4 digits that appear under the barcode on your e-gift card or on the back of your physical gift card.',
  egiftCardLabel: 'E-Gift Card',
  cardText: 'Your card number is located in the email we sent you.',
  giftCardLabel: 'Gift Card',
  cidText: 'Your CID number is located in the email we sent you.',
  termsAndConditions: `For balance inquiry, call 1-800-511-2752 or go to bloomingdales.com/gcbal.
      This card is redeemable only for merchandise and in-store services at Bloomingdale’s,
      Bloomingdale’s The Outlet Store, Bloomie’s and bloomingdales.com (US only); it may not
      be redeemed for cash (except as required by law) or applied as payment or credit to any
      credit card account. Bloomingdale’s reserves the right to decline cards from unauthorized sellers,
      including auction sites. This card may be placed on hold or rejected if fraud is suspected.
      Protect this card: you are responsible if it is lost or stolen. Lost or stolen cards will only
      be replaced with proof of purchase and only for the value shown on our records. This card is
      issued by Bloomingdale’s, LLC and is required for all inquiries.<br>
      Never share a gift card number or 4 digit security code with someone you don’t know.`,
};

export const NEED_HELP = {
  needHelpText: 'Need help?',
  phoneNumber: '1-800-777-0000',
  callText: 'Call',
};
